import { useIntl } from "react-intl";
import { Paper, Typography } from "@mui/material";
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from "recharts";

import {
  getModelLabel,
  METRIC_EXPLANATIONS,
  METRICS,
  MODEL_COLORS,
  pct,
} from "./constants";
import { MLMetrics } from "./services";

const MetricsRadar = ({ model }: { model: MLMetrics }) => {
  const intl = useIntl();

  // An unavailable metric (null AUC) is left out rather than drawn as 0.
  const chartData = METRICS.flatMap((key) => {
    const value = model[key as keyof MLMetrics] as number | null;
    return value === null
      ? []
      : [{ metric: METRIC_EXPLANATIONS[key]!.label, value }];
  });

  return (
    <Paper elevation={1} sx={{ p: 2, flex: "1 1 300px" }}>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          mb: 1,
        }}
      >
        {intl.formatMessage({ id: "ML_ANALYSIS_CHART_TITLE" })}
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={chartData}>
          <PolarGrid />
          <PolarAngleAxis dataKey="metric" tick={{ fontSize: 11 }} />
          <PolarRadiusAxis
            domain={[0, 1]}
            tickFormatter={(v) => pct(v)}
            tick={{ fontSize: 9 }}
          />
          <Radar
            name={getModelLabel(model.model_name)}
            dataKey="value"
            stroke={MODEL_COLORS["prob_vente"]}
            fill={MODEL_COLORS["prob_vente"]}
            fillOpacity={0.2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default MetricsRadar;
